export const createSubLineRequisitionMock = {
	requisitionId: 0,
};

export default createSubLineRequisitionMock;
